import { extractNumber } from '@cred/shared/utils'

const isZero = (value, numberValue) =>
  (value === 0 && Number.isNaN(numberValue)) || numberValue === 0

const MIN_MAX_ERROR_BHG = 'Please enter an amount between $600 and $200,000'
const MIN_MAX_ERROR = 'Please enter an amount between $1,000 and $100,000'

export const minMaxLoanAmount = (value) => {
  const numberValue = extractNumber(value)
  let error

  if (isZero(value, numberValue)) {
    error = MIN_MAX_ERROR
  } else if (numberValue < 1000 || numberValue > 100000) {
    error = MIN_MAX_ERROR
  }

  return error
}

export const minMaxLoanAmountWithBhg = (value) => {
  const numberValue = extractNumber(value)
  let error

  if (isZero(value, numberValue)) {
    error = MIN_MAX_ERROR_BHG
  } else if (numberValue < 600 || numberValue > 200000) {
    error = MIN_MAX_ERROR_BHG
  }

  return error
}
